import React from 'react';

interface Props {
  subtotalTaxable: number;
  totalIgst: number;
  totalCgst: number;
  totalSgst: number;
  roundOff: number;
  grandTotal: number;
  isInterState: boolean;
  isSaving: boolean;
  onSave: () => void;
}

export const PaymentSummaryCard: React.FC<Props> = ({
  subtotalTaxable,
  totalIgst,
  totalCgst,
  totalSgst,
  roundOff,
  grandTotal,
  isInterState,
  isSaving,
  onSave
}) => {
  return (
    <div className="rounded-2xl border border-cyan-500/30 bg-[#12141a] p-5 space-y-3 text-xs">
      <div className="text-xs font-bold uppercase text-cyan-400 border-b border-white/5 pb-2">
        Payment Summary
      </div>

      <div className="space-y-1.5">
        <div className="flex justify-between text-slate-400">
          <span>Taxable Subtotal:</span>
          <span className="font-mono text-white">₹{subtotalTaxable.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
        </div>

        {isInterState ? (
          <div className="flex justify-between text-cyan-300">
            <span>IGST (Inter-State):</span>
            <span className="font-mono">₹{totalIgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
          </div>
        ) : (
          <>
            <div className="flex justify-between text-slate-300">
              <span>CGST:</span>
              <span className="font-mono">₹{totalCgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
            </div>
            <div className="flex justify-between text-slate-300">
              <span>SGST:</span>
              <span className="font-mono">₹{totalSgst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</span>
            </div>
          </>
        )}

        {roundOff !== 0 && (
          <div className="flex justify-between text-slate-500 text-[11px]">
            <span>Round Off:</span>
            <span className="font-mono">₹{roundOff.toFixed(2)}</span>
          </div>
        )}

        <div className="border-t border-white/10 pt-2 flex justify-between font-bold text-sm text-white">
          <span>Grand Total:</span>
          <span className="font-mono text-lg text-cyan-300 font-black">
            ₹{grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
          </span>
        </div>
      </div>

      <div className="pt-2">
        <button
          type="button"
          onClick={onSave}
          disabled={isSaving}
          className="w-full py-2.5 rounded-xl bg-cyan-500 hover:bg-cyan-400 text-black font-bold text-xs transition shadow-md shadow-cyan-500/20"
        >
          {isSaving ? 'Saving...' : 'Save & Issue Invoice'}
        </button>
      </div>
    </div>
  );
};
